/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_Windows_DescInputs */

const en_cad_download_windows_desc = /** @type {(inputs: Cad_Download_Windows_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`64-bit MSI installer for most Windows 10 and 11 PCs`)
};

/**
* | output |
* | --- |
* | "64-bit MSI installer for most Windows 10 and 11 PCs" |
*
* @param {Cad_Download_Windows_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_windows_desc = /** @type {((inputs?: Cad_Download_Windows_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_Windows_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_windows_desc(inputs)
});
export { cad_download_windows_desc as "cad.download.windows_desc" }